module.exports = __webpack_public_path__ + "img/map-marker.5e14162a.png";